<template>
    <div class="rfq" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="客户公司">
                        <el-select v-model="searchForm.customerId" placeholder="请选择客户公司" :loading="unitsLoading" clearable filterable size="mini" style="width: 230px;">
                            <el-option
                                v-for="item in customers"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="tableData"
                    v-loading="loading"
                    :max-height="tableHeight"
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column prop="customer" label="公司名称" width="180"></el-table-column>
                    <el-table-column prop="sku" label="SKU" width="100"></el-table-column>
                    <el-table-column prop="name" label="商品名称"></el-table-column>
                    <el-table-column prop="brand" label="商品品牌" width="180"></el-table-column>
                    <el-table-column prop="supplierUntaxedPrice" label="采购未税价格" width="120"></el-table-column>
                    <el-table-column prop="supplierPrice" label="采购含税税价格" width="120"></el-table-column>
                    <el-table-column prop="untaxedPrice" label="销售未税价格" width="120"></el-table-column>
                    <el-table-column prop="price" label="销售含税税价格" width="120"></el-table-column>
                    <el-table-column prop="profitMargin" label="利润率(%)" width="100">
                        <template slot-scope="scope">
                            {{ ((scope.row.price - scope.row.supplierPrice) * 100 / scope.row.supplierPrice).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="商品状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 1" size="mini">已上架</el-tag>
                            <el-tag v-if="scope.row.status === 0" size="mini" type="info">已下架</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pushStatus" label="推送状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.pushStatus === 1" size="mini">已推送</el-tag>
                            <el-tag v-if="scope.row.pushStatus === 0" size="mini" type="warning">等待推送</el-tag>
                            <el-tooltip v-if="scope.row.pushStatus === 2" :content="scope.row.message" placement="top">
                                <el-tag size="mini" type="danger">推送失败</el-tag>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="200" align="right" fixed="right">
                        <template slot="header" slot-scope="header">
                            <el-button type="primary" size="mini" @click="handleShowPushProductDialog()">推送商品</el-button>

                            <el-dropdown style="margin-left: 4px" @command="more">
                                <el-button type="primary" size="mini">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown" @command="more">
                                    <el-dropdown-item command="many">批量推送
                                    </el-dropdown-item>
                                    <el-dropdown-item command="template">
                                        <a href="/template/批量推送模板.xlsx" style="margin-right:16px">批量推送模板</a>
                                    </el-dropdown-item>
<!--                                    <el-dropdown-item command="many">批量导入</el-dropdown-item>-->
                                    <el-dropdown-item command="putOn">批量上架</el-dropdown-item>
                                    <el-dropdown-item command="pullOff">批量下架</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" size="mini" @click="handlePushAll()">批量推送</el-button> -->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleShowUpdatePriceDialog(scope.row)">修改价格</el-button>
                            <!-- <el-button v-if="scope.row.status === 0" type="text" size="mini" @click="handlePutOn(scope.row)">上架</el-button>
                            <el-button v-if="scope.row.status === 1" type="text" size="mini" @click="handlePullOff(scope.row)">下架</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        stripe
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="推送新商品" :visible.sync="pushProductDialogVisible" width="1200px" :close-on-click-modal="false">
            <el-form ref="searchProductForm" :inline="true" :model="searchProductForm" :rules="searchProductFormRules" label-width="90px">
                <el-form-item label="供应商" prop="supplierId" size="mini">
                    <el-select v-model="searchProductForm.supplierId" placeholder="请选择供应商" clearable>
                        <el-option
                            v-for="item in suppliers"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="查询内容" prop="searchKey" size="mini">
                    <el-input v-model="searchProductForm.searchKey" placeholder="请输入SKU或商品名称1" @keyup.enter.native="onSearchProduct()" clearable></el-input>
                </el-form-item>
                <el-button type="primary" @click="onSearchProduct()" size="mini">查询</el-button>
            </el-form>
            <el-table
                size="mini"
                height="200"
                ref="tableProductData"
                :data="tableProductData"
                v-loading="productDataLoading"
                highlight-current-row
                @row-click="selectProduct"
                style="width: 100%">
                <el-table-column prop="sku" label="SKU" width="100"></el-table-column>
                <el-table-column prop="shotName" label="商品简称" width="80"></el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
                <el-table-column prop="brand" label="商品品牌" width="80"></el-table-column>
                <el-table-column prop="unit" label="销售单位" width="70"></el-table-column>
                <el-table-column prop="moq" label="最小起订量" width="80"></el-table-column>
                <el-table-column prop="supplierUntaxedPrice" label="采购未税" width="80"></el-table-column>
                <el-table-column prop="supplierPrice" label="采购含税" width="80"></el-table-column>
                <el-table-column prop="untaxedPrice" label="销售未税" width="80"></el-table-column>
                <el-table-column prop="price" label="销售含税" width="80"></el-table-column>
                <el-table-column prop="officialPrice" label="面价" width="80"></el-table-column>
                <el-table-column prop="supplier" label="供应商" width="180"></el-table-column>
            </el-table>
            <el-divider></el-divider>
            <el-descriptions title="商品信息" style="padding: 0 20px">
                <el-descriptions-item label="SKU">{{ selectedProduct.sku }}</el-descriptions-item>
                <el-descriptions-item label="商品名称" span="2">{{ selectedProduct.productName }}</el-descriptions-item>
                <el-descriptions-item label="商品简称">{{ selectedProduct.shortName }}</el-descriptions-item>
                <el-descriptions-item label="商品品牌">{{ selectedProduct.brand }}</el-descriptions-item>
                <el-descriptions-item label="销售单位">{{ selectedProduct.unit }}</el-descriptions-item>
                <el-descriptions-item label="采购未税价格">{{ selectedProduct.supplierUntaxedPrice }}</el-descriptions-item>
                <el-descriptions-item label="采购含税税价格">{{ selectedProduct.supplierPrice }}</el-descriptions-item>
                <el-descriptions-item label="面价">{{ selectedProduct.officialPrice }}</el-descriptions-item>
                <el-descriptions-item label="最小起订量">{{ selectedProduct.moq }}</el-descriptions-item>
                <el-descriptions-item label="供应商" span="2">{{ selectedProduct.supplier }}</el-descriptions-item>
            </el-descriptions>
            <el-divider>推送商品信息配置</el-divider>
            <el-form ref="pushProductForm" :inline="true" :model="pushProductForm" :rules="pushProductFormRules" label-width="90px">
                <el-row>
                    <el-form-item label="客户公司" prop="customer" size="mini">
                        <el-select v-model="pushProduct.customer" placeholder="请选择客户公司" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in customers"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="SKU" prop="sku" size="mini">
                        <el-input v-model="pushProduct.sku" disabled style="width: 230px;" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="品牌" prop="brand" size="mini">
                        <el-select v-model="pushProduct.brand" placeholder="请选择品牌" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in brands"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品名称" prop="name" size="mini">
                        <el-radio-group v-model="pushProduct.name">
                            <el-radio :label="pushProduct.productName"></el-radio>
                            <el-radio :label="pushProduct.shortName"></el-radio>
                            <el-radio label="自定义"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="pushProduct.name === '自定义'" label="" prop="customName" size="mini">
                        <el-input v-model="pushProduct.customName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="pushProduct.officialPrice" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row>
                <!-- <el-row>
                    <el-form-item label="销售单位" prop="unit" size="mini">
                        <el-select v-model="pushProduct.unit" placeholder="请选择销售单位" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in units"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="pushProduct.officialPrice" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row> -->
                <el-row>
                    <el-form-item label="含税售价" prop="price" size="mini">
                        <el-input v-model="pushProduct.price" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="税率" prop="tax" size="mini">
                        <el-input v-model="pushProduct.tax" clearable>
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="未税售价" size="mini">
                        <el-input v-model="untaxedPrice" disabled clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pushProductDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handlePush" :disabled="!canPush" size="small">推 送</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更新商品价格" :visible.sync="updatePriceDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form ref="updatePriceForm" :model="updatePriceForm" :rules="updatePriceFormRules" label-width="90px">
                <el-row>
                    <el-form-item label="SKU" prop="sku" size="mini">
                        <el-input v-model="updatePriceForm.sku" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品名称" prop="name" size="mini">
                        <el-input v-model="updatePriceForm.name" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="updatePriceForm.officialPrice" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="销售价格" prop="price" size="mini">
                        <el-input v-model="updatePriceForm.price" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="税率" prop="tax" size="mini">
                        <el-input v-model="updatePriceForm.tax" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="未税售价" prop="newUntaxedPrice" size="mini">
                        <el-input v-model="newUntaxedPrice" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updatePriceDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleUpdatePrice" size="small">更 新</el-button>
            </div>
        </el-dialog>
        <el-dialog title="批量推送" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                       class="upload-demo"
                       drag
                       action="/api/admin/mall/jcy/uploadPushProduct"
                       :limit="1"
                       accept=".xlsx"
                       :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>

export default {

    data() {
        return {
            pushProductDialogVisible:false,
            companys:[],
            users: [],
            searchForm: {
                companyName: ""
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            editForm: {},

            searchProductForm: {},
            productDataLoading: false,
            tableProductData: [],

            pushProductForm: {},
            selectedProduct: {},
            pushProduct: {
                productName: '商品名称',
                shortName: '商品简称',
            },
            units: [],
            unitsLoading: false,

            brands: [],
            customers: [],

            selectData: [],

            updatePriceDialogVisible: false,
            updatePriceForm: {},

            rules: {
                companyId: [
                    { required: true, message: '请选择客户公司', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择下单账号', trigger: 'blur' }
                ],
                supplierId: [
                    { required: true, message: '请输入供应商ID', trigger: 'blur' }
                ],
                appKey: [
                    { required: true, message: '请输入MRO账号', trigger: 'blur' }
                ],
                appSecret: [
                    { required: true, message: '请输入MRO密码', trigger: 'blur' }
                ],
                mallAppKey: [
                    { required: true, message: '请输入商城账号', trigger: 'blur' }
                ],
                mallAppSecret: [
                    { required: true, message: '请输入商城密码', trigger: 'blur' }
                ],
            },
            searchProductFormRules: {
                searchKey: [
                    { required: true, message: '请输入查询内容', trigger: 'blur' }
                ],
            },
            pushProductFormRules: {
                searchKey: [
                    { required: true, message: 'SKU不能为空', trigger: 'blur' }
                ],
            },
            updatePriceFormRules: {

            },
            uploadDialogVisible: false,
            uploadCheckResult: "",
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let cond = {...this.searchForm};

            this.$axios.post("/admin/mall/jcy/searchJcyProduct",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            }).finally(() => {
                _this.loading = false;
            });
        },
        loadSuppliers(){
            const that = this;
            this.$axios.get("/admin/supplier/loadSuppliers"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.suppliers = resp.data;
                }
            });
        },
        onSearchProduct() {
            let that = this;
            this.$refs.searchProductForm.validate(valid => {
                if(valid) {
                    that.tableProductData = [];
                    that.selectedProduct = {};
                    this.productDataLoading = true;
                    this.$axios.post("/admin/mall/jcy/searchProduct",{...this.searchProductForm})
                    .then(function(response) {
                        let resp = response.data;
                        if( resp.header.status == 0) {
                            that.tableProductData = resp.data;
                        }
                    }).catch(function() {
                    }).finally(() => {
                        that.productDataLoading = false;
                    });
                }
            });
        },
        selectProduct(row) {
            this.$refs.tableProductData.setCurrentRow(row);
            this.selectedProduct=row;
            this.pushProduct={
                ...row,
                tax: 13,
                unit: null,
                brand: null,
            };
            if(row['sku']) {
                const that = this;
                this.unitsLoading = true;
                this.$axios.get(`/admin/mall/jcy/loadCategoryUnits/${row['sku']}`)
                .then(function(response) {
                    let resp = response.data;
                    if( resp.header.status == 0) {
                        that.units = resp.data;
                        const newPushProduct = {...that.pushProduct};
                        const validUnits = that.units.filter(u => u['value'] === row['unit']);
                        if(validUnits.length > 0) {
                            newPushProduct['unit'] = validUnits[0].key;
                            // that.pushProduct = {
                            //     ...that.pushProduct,
                            //     unit: validUnits[0].key,
                            // }
                        }
                        const validBrands = that.brands.filter(b => b['value'] === row['brandd']);
                        if(validBrands.length > 0) {
                            newPushProduct['brand'] = validBrands[0].key;
                        }
                        that.pushProduct = {...newPushProduct};
                    }
                }).catch(function() {
                }).finally(() => {
                    that.productDataLoading = false;
                    that.unitsLoading = false;
                });
            }
        },
        handleShowPushProductDialog() {
            this.pushProductDialogVisible = true;
            this.searchProductForm = {};
            this.tableProductData = [];
            this.pushProductForm = {};
            this.selectedProduct = {};
            this.pushProduct = {
                productName: '商品名称',
                shortName: '商品简称',
            };
            this.units = [];
        },
        handlePush() {
            const message = [];
            const salePrice = Number(this.pushProduct.price);
            const supplierPrice = Number(this.selectedProduct.supplierPrice);
            const officialPrice = Number(this.selectedProduct.officialPrice);
            if(Number.isFinite(salePrice) && Number.isFinite(supplierPrice) && salePrice < supplierPrice) {
                message.push("销售价格小于采购价格");
            }
            if(Number.isFinite(salePrice) && Number.isFinite(officialPrice) && salePrice > officialPrice) {
                message.push(salePrice+"+销售价格大于面价"+officialPrice);
            }
            if(message.length > 0) {
                this.$confirm(`${message.join(' 且 ')}，确定推送?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.onPushProduct();
                });
            } else {
                this.onPushProduct();
            }
        },
        onPushProduct() {
            const {customer, sku, name, customName, brand, unit, tax, price, officialPrice, } = this.pushProduct;
            const that = this;
            this.$axios.post('/admin/mall/jcy/pushProduct', {
                customer, sku, productName: name === '自定义' ? customName : name, brand, unit, officialPrice, price, tax,
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status === 0) {
                    that.onSearch();
                    that.pushProductDialogVisible = false;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            }).catch(function() {
            }).finally(() => {
            });
        },
        handlePushAll() {},
        handleShowUpdatePriceDialog(row) {
            this.updatePriceForm = {
                ...row,
                tax: row.tax * 100,
            };
            this.updatePriceDialogVisible = true;
        },
        handleUpdatePrice() {
            const that = this;
            const {id, officialPrice, price, tax} = this.updatePriceForm;
            this.$axios.post('/admin/mall/jcy/updatePrice', {id, officialPrice, price, tax})
            .then(function(response) {
                let resp = response.data;
                if( resp.header.status === 0) {
                    that.onSearch();
                    that.updatePriceDialogVisible = false;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        loadBrands() {
            const that = this;
            this.$axios.get("/admin/mall/jcy/loadBrands"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.brands = resp.data;
                }
            });
        },
        loadCustomers() {
            const that = this;
            this.$axios.get("/admin/mall/jcy/loadCustomers"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.customers = resp.data;
                }
            });
        },
        pushMany() {
            this.uploadCheckResult = "";
            this.uploadDialogVisible = true;

        },
        more(command) {
            if(command == "many"){

                this.pushMany();
                return;
            }

            if(this.selectData.length === 0) {
                return;
            }
            const that = this;
            switch(command) {

                case 'putOn':
                    // this.loading = true;
                    this.$confirm('确定上架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/mall/jcy/putOn",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status !== 0) {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                            that.onSearch();
                        }).finally(() => {
                        });
                    });
                    break;
                case 'pullOff':
                    // this.loading = true;
                    this.$confirm('确定下架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/mall/jcy/pullOff",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status !== 0) {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                            that.onSearch();
                        }).finally(() => {
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
                // this.$notify({
                //     title: '失败',
                //     message: msg,
                //     type: 'error',
                //     duration: 5000,
                // });

            }
        },
    },
    created() {
        this.onSearch();
        this.loadSuppliers();
        this.loadBrands();
        this.loadCustomers();
    },
    computed: {
        untaxedPrice() {
            if(this.pushProduct.price && this.pushProduct.tax) {
                return (Number.parseFloat(this.pushProduct.price) * 100 / (100+Number.parseFloat(this.pushProduct.tax))).toFixed(2);
            } else {
                return "";
            }
        },
        newUntaxedPrice() {
            if(this.updatePriceForm.price && this.updatePriceForm.tax) {
                return (Number.parseFloat(this.updatePriceForm.price) * 100 / (100+Number.parseFloat(this.updatePriceForm.tax))).toFixed(2);
            } else {
                return "";
            }
        },
        canPush() {
            return ((this.pushProduct.name && this.pushProduct.name != '自定义') || this.pushProduct.customName)
            && this.pushProduct.customer
            && this.pushProduct.sku
            && this.pushProduct.brand
            && this.pushProduct.price
            && this.pushProduct.untaxedPrice
            && this.pushProduct.tax;
        },
        tableHeight() {
            return this.$store.state.clientHeight - 320;
        }
    }
}
</script>
